import { useTranslation } from 'react-i18next';
import Spinner from '../Fundamentals/Spinner/Spinner';
import { Button, ButtonOption } from '../Fundamentals/Button';
import GoogleSignInButton from '../Fundamentals/GoogleSignInButton/GoogleSignInButton';
import type { ScreenPopStatus } from '../../Containers/ScreenPop/ScreenPop.types';

interface ScreenPopViewProps {
    status: ScreenPopStatus;
    onSignIn: () => void;
    onRetry: () => void;
}

const HUBSPOT_HOME = 'https://app-eu1.hubspot.com';

const ScreenPopView = ({ status, onSignIn, onRetry }: ScreenPopViewProps) => {
    const { t } = useTranslation();

    if (status === 'signInFailed') {
        return (
            <div className="alert alert-warning" role="alert">
                <p>{t('screenpop.signInFailed')}</p>
                <GoogleSignInButton label={t('screenpop.signIn')} onClick={onSignIn} />
            </div>
        );
    }

    if (status === 'error') {
        return (
            <div className="alert alert-danger" role="alert">
                <strong>{t('screenpop.errorTitle')}</strong>
                {/* Never the server's message: for a HubSpot rejection it is the raw API response. Details are in Application Insights. */}
                <p>{t('screenpop.errorBody')}</p>
                <div className="d-flex gap-8">
                    <Button option={ButtonOption.PRIMARY} onClick={onRetry}>
                        {t('screenpop.retry')}
                    </Button>
                    <a className="btn btn-sm" href={HUBSPOT_HOME}>
                        {t('screenpop.openHubSpot')}
                    </a>
                </div>
            </div>
        );
    }

    return (
        <div className="d-flex flex-column align-items-center gap-16">
            <Spinner />
            <p>{t(status === 'creating' ? 'screenpop.creating' : 'screenpop.signingIn')}</p>
        </div>
    );
};

export default ScreenPopView;
